var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "options order-specification" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "aside" }, [
        _c("div", { staticClass: "optionsPanel" }, [
          _c("div", { staticClass: "optionsPanel__image" }, [
            _c("img", {
              staticClass: "manufacturer_image",
              attrs: { src: _vm.getMachineImage() }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "optionsPanel__content optionsPanel__content--borderTop"
            },
            [
              _c("h5", [
                _vm._v("Total current cost per annum "),
                _c("span", {
                  staticClass: "cost",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$root.mnwp(
                        _vm.order.current_costs.total_cost_per_annum.toFixed(2)
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "cost" }, [
                  _vm._v("\n                ("),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$root.mnwp(
                          (
                            _vm.order.current_costs.total_cost_per_annum / 4
                          ).toFixed(2)
                        )
                      )
                    }
                  }),
                  _vm._v(" per quarter)\n              ")
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "small" }, [
                _vm._v(
                  "*Calculated using existing service costs, consumable costs, postage\n            recredits, invoice fees and insurance fees\n            where applicable based on information provided"
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.videoEmbed
          ? _c("div", { staticClass: "optionsPanel" }, [
              _c(
                "div",
                {
                  staticClass:
                    "optionsPanel__content optionsPanel__content--borderTop"
                },
                [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.order.costs.printer.model) + " demo video"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.videoEmbed) } })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "optionsPanel" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-gradient",
              on: {
                click: function($event) {
                  return _vm.closeSpecification()
                }
              }
            },
            [_vm._v("Return To Order")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table" },
        [_c("features", { attrs: { order: _vm.order } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "close",
          on: {
            click: function($event) {
              return _vm.closeSpecification()
            }
          }
        },
        [_vm._m(0)]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-times" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5142c7cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5142c7cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/specification/Specification.vue
// module id = null
// module chunks = 